import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function BeforeAfterSection() {
  const beforeItems = ['Clientes desordenados', 'Vencimientos olvidados', 'Documentos perdidos', 'Horas buscando información'];
  const afterItems = ['Clientes organizados', 'Vencimientos bajo control', 'Documentación centralizada', 'Trabajo contable más eficiente'];
  return <section className="py-12 sm:py-20 px-4 bg-[#0B1A2E]" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="grid grid-cols-2 gap-3 sm:gap-6 md:gap-10" data-id="element-17">
          {/* Before Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-red-950/20 border border-red-900/30 rounded-2xl p-4 sm:p-8 relative overflow-hidden" data-id="element-18">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500/50" data-id="element-19" />
            <h3 className="text-lg sm:text-2xl font-bold text-red-400 mb-3 sm:mb-6 text-center" data-id="element-20">
              Antes
            </h3>
            <ul className="space-y-2 sm:space-y-4" data-id="element-21">
              {beforeItems.map((item, index) => <li key={index} className="flex items-center gap-2 sm:gap-3 text-slate-300 text-sm sm:text-base" data-id="element-22">
                  <XIcon className="w-4 h-4 sm:w-5 sm:h-5 text-red-500 flex-shrink-0" data-id="element-23" />
                  <span data-id="element-24">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* After Column */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-green-950/20 border border-green-900/30 rounded-2xl p-4 sm:p-8 relative overflow-hidden" data-id="element-25">
            <div className="absolute top-0 left-0 w-full h-1 bg-green-500/50" data-id="element-26" />
            <h3 className="text-lg sm:text-2xl font-bold text-green-400 mb-3 sm:mb-6 text-center" data-id="element-27">
              Después
            </h3>
            <ul className="space-y-2 sm:space-y-4" data-id="element-28">
              {afterItems.map((item, index) => <li key={index} className="flex items-center gap-2 sm:gap-3 text-slate-200 text-sm sm:text-base" data-id="element-29">
                  <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-green-500 flex-shrink-0" data-id="element-30" />
                  <span className="font-medium" data-id="element-31">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}